import { c as _c } from "react/compiler-runtime";
import { useMutation } from '@tanstack/react-query';
import { baseFetch } from '@/infra/http/base';
import type { GiftFormData } from '../_utils/schema';
interface GiftMutationResponse {
  url: string;
}
export function useGiftMutation() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: _temp2,
      onSuccess: _temp3,
      onError: _temp4
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
}
function _temp4(error_0) {
  console.error("Failed to create gift:", error_0);
}
function _temp3(data_0) {
  if (data_0.url) {
    window.location.href = data_0.url;
  }
}
async function _temp2(formData) {
  ;
  try {
    formData.recipients = formData.recipients.map(_temp);
    const response = await baseFetch.post("public/gifts", {
      json: formData
    });
    const data = await response.json();
    return data;
  } catch (t0) {
    const error = t0;
    console.error("\uD83D\uDE80 ~ useGiftMutation ~ error:", error);
    throw error;
  }
}
function _temp(recipient) {
  if (recipient.message === "" || recipient.message === null) {
    recipient.message = undefined;
  }
  return recipient;
}